<script>
import {mapGetters, mapState} from "vuex";
import Tile from '@/components/tile.vue';
import planCommon from './mixin';
import { BILLING_CYCLE, BUNDLE_WITH_ZP_BASE_PLAN_TYPES, planTypes } from '@/common/constants';
import base from '@/views/config/addon-cards/templates/base.vue';
import {
  computedActiveUnlimitedCallingPlans,
  computedCallingPlans,
  computedPbxCallingPlans,
  computedPbxPlans,
} from '@/common/service/computers/plans/pbx';
import store from '@/store';
import { hasZoomPhoneFreeTrialPlan } from '@/plans/ZOOM_PHONE/helper/utils';
import { isBizPlusContext, isEduSchCmpPlusContext, isProPlusContext } from '../ZOOM_MEETING/common/utils';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';
import { softBundleForAddon, softBundleUtils } from '@/views/config/soft-bundle/helper';
import { getPlanLogo } from '@/common/plan-logo-map';

const isForRecommendedAddon = softBundleForAddon[planTypes.ZOOM_PHONE$ZPI].test();

export default {
  name: 'ZoomPhoneInternationalAddOn',
  mixins: [base, planCommon],
  components: {
    Tile,
  },
  recommended: isForRecommendedAddon,
  for:() => {
    // Hide addon if user has Zoom Phone free trial plan
    if (hasZoomPhoneFreeTrialPlan()) {
      return false;
    }
    if (softBundleUtils.isSoftBundleBizPlus()) { return true; }
    const hasZoomPhoneWinBack = store.getters.pastPlans.some(plan => [...BUNDLE_WITH_ZP_BASE_PLAN_TYPES, planTypes.ZOOM_PHONE].includes(planTypes[plan.semanticType]));
    if (hasZoomPhoneWinBack) {
      return false;
    }
    const isContainBasePlan = store.getters.getSelectedPlans.some(plan => [planTypes.ZOOM_PHONE, planTypes.ZONE_PRO_PLUS].includes(plan.type));
    if(isFromShoppingCart() && !isContainBasePlan) {
      return false;
    }
    if(isProPlusContext) return true;
    if(isBizPlusContext) return false;
    if (isEduSchCmpPlusContext) return false
    const mergePlanList = store.getters.getUserCurrentSubscriptions;
    const pbxUnlimitedPlans = computedActiveUnlimitedCallingPlans(mergePlanList);
    // zoom phone addon add flow
    if(store.getters.isZPAContext) {
      return false;
    }
    return pbxUnlimitedPlans.length;
  },
  created() {
    if(this.defaultPlan) {
      const { amount, billing_cycle } = this.defaultPlan;
      this.subtitle = this.$money(amount) + this.$t(`billing.common.per_billing_cycle_license.${billing_cycle}`);
      this.productPlans = this.currentProductPlans;
    }
  },

  data() {
    const recommended = this.$t('billing.cmr.recommended') || "";

    return {
      logo: getPlanLogo(planTypes.ZOOM_PHONE$ZPI),
      promo: isForRecommendedAddon ? recommended.toUpperCase?.() : "",
    };
  },

  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      getSelectedPlans: 'getSelectedPlans',
      getUserCurrentSubscriptions: 'getUserCurrentSubscriptions'
    }),
    callingPlanType() {
      const callingPlan = computedPbxCallingPlans(this.getSelectedPlans)[0];
      if(callingPlan) {
        return callingPlan.sub_type;
      }
      return '';
    },
    currentBillingCycle() {
      const selectCallingPlan = computedCallingPlans(this.getUserCurrentSubscriptions)[0];
      if(selectCallingPlan) {
        return selectCallingPlan.billing_cycle;
      }
      return BILLING_CYCLE.ANNUAL;
    },
    currentProductPlans() {
      return computedPbxPlans(this.planMapFlat).filter(item => item.category === 'ZPI');
    },
    defaultPlan() {
      return this.currentProductPlans.find(item => item.billing_cycle === this.currentBillingCycle);
    },
  },
  methods: {
    addOn() {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      document.addPlanFromEnterKey = true;
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction('zoom phone add-ons', `add-ons - ${this.title?.toLowerCase()} - ${this.trackingAddAction}`);
    },
  },
  watch: {
    defaultPlan(value) {
      if(value) {
        const { amount, billing_cycle } = value;
        this.subtitle = this.$money(amount) + this.$t(`billing.common.per_billing_cycle_license.${billing_cycle}`);
      }
    },
  },
};
</script>
